import { Box, styled } from '@mui/material';

export const EditModeWrapper = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  position: 'relative',

  '.MuiFormHelperText-root': {
    whiteSpace: 'normal !important',
    wordBreak: 'break-word',
  },
}));

export const ButtonsContainer = styled(Box)(() => ({
  position: 'absolute',
  right: 0,
  top: '100%',
  zIndex: 2,
  display: 'flex',
  gap: '1px',
  marginTop: '4px',
  backgroundColor: '#fff',
  padding: '4px',
  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  borderRadius: '4px',
}));
